import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';
import Ionicon from 'react-ionicons';

const Bg = styled.div`
  background-color: ${props => props.theme.bg};
  height: 45px;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-around;
`;

const BottomTabBar = ({ theme, selected }) => {
  const { active, icon } = theme.botBar;
  return (
    <ThemeProvider theme={theme}>
      <Bg>
        <Row>
          <Ionicon icon="logo-bitcoin" fontSize="24px" color={selected === 'favorites' ? active : icon} />
          <Ionicon icon="ios-pulse" fontSize="24px" color={selected === 'marketcap' ? active : icon} />
          <Ionicon icon="ios-pie" fontSize="24px" color={selected === 'portfolio' ? active : icon} />
          <Ionicon icon="ios-calculator" fontSize="24px" color={selected === 'calculator' ? active : icon} />
          <Ionicon icon="ios-settings" fontSize="24px" color={selected === 'settings' ? active : icon} />
        </Row>
      </Bg>
    </ThemeProvider>
  );
};

export default withTheme(BottomTabBar);



// WEBPACK FOOTER //
// ./src/components/BottomTabBar.js